import type { ApiServiceUnitConversion, EnumUnit } from '@Model';
import { getEnumUnitLabel, unitOptions } from '@Model';
import {
    Badge,
    ConvertIndicator,
    FlexRow,
    Grid,
    GridColumns,
    type ISubFrameBodyProps,
    LabeledDiv,
    NumberInput,
    Select,
    useGuiBinder,
    useTranslate,
} from '@synqo/frontend-component-library';

type IFrameEditServiceUnitConversionProps = ISubFrameBodyProps<ApiServiceUnitConversion>;

export function FrameEditServiceConversions(props: IFrameEditServiceUnitConversionProps) {
    const i18n = useTranslate('');

    const apiConversion: ApiServiceUnitConversion = props.data;
    const binder = useGuiBinder<ApiServiceUnitConversion>(props);

    return (
        <Grid columns={16}>
            <GridColumns spans={[3, 4, 2, 3, 4]}>
                <LabeledDiv htmlFor="" label="Menge">
                    <Badge size="sm" type="input" variant="primary">
                        1
                    </Badge>
                </LabeledDiv>

                <LabeledDiv htmlFor="" label="Ausgangseinheit">
                    <Badge size="sm" type="input" variant="primary">
                        {getEnumUnitLabel(apiConversion.source_unit)}
                    </Badge>
                </LabeledDiv>

                <FlexRow maximize height="100%" justify="center">
                    <ConvertIndicator />
                </FlexRow>

                <NumberInput {...binder.bindToProp('factor')} label={i18n('Menge')} />
                <Select
                    items={unitOptions}
                    {...binder.bindToAutoConfirmed<EnumUnit>('target_unit')}
                    label={i18n('Zieleinheit')}
                />
            </GridColumns>
        </Grid>
    );
}
